import basePageFields from '@fragments/pages/basePageFields';

import EventSummaryFragment from '@fragments/summaries/EventSummaryFragment';
import SubnavFragment from '@fragments/shared/SubnavFragment';

export default gql`
    fragment EventsLandingFragment on EventsLanding {
        ${basePageFields}
        featuredEvents {
            ...EventSummaryFragment
        }
        subNav {
            ...SubnavFragment
        }
        upcomingEvents
        contentType: _collection
    }

    ${EventSummaryFragment}
    ${SubnavFragment}
`;
